import { MIN_LOAN_AMOUNT } from '@repo/shared/constants';
export var getDefaultProvider = function (merchantResponseData) {
    var _a, _b, _c, _d, _e;
    var defaultProviderConfig = merchantResponseData === null || merchantResponseData === void 0 ? void 0 : merchantResponseData.config.find(function (providerConfig) { return providerConfig.default; });
    if (!defaultProviderConfig) {
        var providers = (_a = merchantResponseData === null || merchantResponseData === void 0 ? void 0 : merchantResponseData.currentProvider) !== null && _a !== void 0 ? _a : [];
        var _loop_1 = function (provider) {
            var hasValidLimit = (_c = (_b = merchantResponseData === null || merchantResponseData === void 0 ? void 0 : merchantResponseData.data) === null || _b === void 0 ? void 0 : _b.limits) === null || _c === void 0 ? void 0 : _c.find(function (limit) { return limit.provider === provider && limit.available > MIN_LOAN_AMOUNT; });
            if (hasValidLimit)
                return { value: provider };
        };
        for (var _i = 0, providers_1 = providers; _i < providers_1.length; _i++) {
            var provider = providers_1[_i];
            var state_1 = _loop_1(provider);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        var _loop_2 = function (provider) {
            var hasValidPreLimit = (_e = (_d = merchantResponseData === null || merchantResponseData === void 0 ? void 0 : merchantResponseData.data) === null || _d === void 0 ? void 0 : _d.preLimits) === null || _e === void 0 ? void 0 : _e.find(function (preLimit) { return preLimit.provider === provider && preLimit.max > MIN_LOAN_AMOUNT; });
            if (hasValidPreLimit)
                return { value: provider };
        };
        for (var _f = 0, providers_2 = providers; _f < providers_2.length; _f++) {
            var provider = providers_2[_f];
            var state_2 = _loop_2(provider);
            if (typeof state_2 === "object")
                return state_2.value;
        }
        return merchantResponseData === null || merchantResponseData === void 0 ? void 0 : merchantResponseData.currentProvider[0];
    }
    return merchantResponseData === null || merchantResponseData === void 0 ? void 0 : merchantResponseData.currentProvider.find(function (currentProviderName) { return currentProviderName === (defaultProviderConfig === null || defaultProviderConfig === void 0 ? void 0 : defaultProviderConfig.provider); });
};
